<template>
  <div>
    <!-- SP表示 -->
    <div class="mb-8 lg:hidden">
      <div
        role="tablist"
        class="tabs-boxed tabs bg-inherit p-0"
      >
        <!-- 8週間 -->
        <input
          type="radio"
          name="price_tab"
          role="tab"
          class="te-tab-8weeks tab min-h-[40px] text-[1rem]"
          aria-label="8週間"
          checked
        >
        <div
          role="tabpanel"
          class="tab-content border-0 text-center"
        >
          <div
            class="flex min-h-[8.1875rem] flex-col justify-center gap-2 bg-co-success-500 p-4 text-white"
          >
            <!-- バッジ -->
            <!-- <img
              class="mx-auto"
              src="~/assets/images/Te/TeCourse/PriceTable/price-badge-sakiwari.svg"
              alt="先割"
              width="61"
              height="34"
              loading="lazy"
            > -->
            <h3 class="co-display-10 mb-0 font-bold">
              8週間プラン
            </h3>
            <span class="co-display-13 font-normal">集中して学びたい方向け</span>
          </div>
          <div>
            <!-- 料金 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <div>
                <b class="font-normal">
                  <span class="co-display-7 px-1 font-bold text-co-success-500">{{ $addComma(standard_week8_price) }}</span> 円（税込）
                </b>
              </div>
            </div>
            <!-- 受講期間 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">受講期間</span>
              <b class="font-normal">
                <span class="mb-2 block">
                  <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
                </span>
                <span class="block">
                  <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt8) }}月{{ dateToDay(membershipEndsAt8) }}日 ({{ dateToWeek(membershipEndsAt8) }})
                </span>
              </b>
            </div>
            <!-- メンタリング -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">メンタリング</span>
              14回
            </div>
            <!-- チャットサポート -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">チャットサポート</span>
              <slot name="chatSupportTime">
                24時間以内に回答
              </slot>
            </div>
            <!-- 学習時間の目安 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">学習時間の目安</span>
              <slot name="studyTime4Weeks">
                40〜50時間
              </slot>
              <br>
              <span class="font-bold">（1週間）</span>
            </div>
          </div>
        </div>
        <!-- 16週間 -->
        <input
          type="radio"
          name="price_tab"
          role="tab"
          class="te-tab-16weeks tab min-h-[40px] text-[1rem]"
          aria-label="16週間"
        >
        <div
          role="tabpanel"
          class="tab-content border-0 text-center"
        >
          <div
            class="flex min-h-[8.1875rem] flex-col justify-center gap-2 bg-[#625fb7] p-4 text-white"
          >
            <!-- バッジ -->
            <img
              class="mx-auto"
              src="~/assets/images/Te/TeCourse/PriceTable/price-badge-sakiwari.svg"
              alt="先割"
              width="61"
              height="34"
              loading="lazy"
            >
            <h3 class="co-display-10 mb-0 font-bold">
              16週間プラン
            </h3>
            <span class="co-display-13 font-normal">焦らず学びたい方向け</span>
          </div>
          <div>
            <!-- 料金 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <div>
                <b class="font-normal">
                  <span class="co-display-7 px-1 font-bold text-[#625fb7]">{{ $addComma(standard_week16_price) }}</span> 円（税込）
                </b>
              </div>
            </div>
            <!-- 受講期間 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">受講期間</span>
              <b class="font-normal">
                <span class="mb-2 block">
                  <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
                </span>
                <span class="block">
                  <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt16) }}月{{ dateToDay(membershipEndsAt16) }}日 ({{ dateToWeek(membershipEndsAt16) }})
                </span>
              </b>
            </div>
            <!-- メンタリング -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">メンタリング</span>
              30回
            </div>
            <!-- チャットサポート -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">チャットサポート</span>
              <slot name="chatSupportTime">
                24時間以内に回答
              </slot>
            </div>
            <!-- 学習時間の目安 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">学習時間の目安</span>
              <slot name="studyTime4Weeks">
                20〜25時間
              </slot>
              <br>
              <span class="font-bold">（1週間）</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PC表示 -->
    <div class="co-container-sm mb-[3.25rem] hidden lg:block">
      <table class="table text-center">
        <thead>
          <tr class="h-[6.25rem]">
            <th class="w-1/5 px-3" />
            <!-- 8週間 -->
            <th class="relative w-2/5 border border-[#dee2e6] bg-co-success-500 px-3 py-0 text-white">
              <!-- バッジ -->
              <!-- <img
                class="absolute -top-[3%] left-1/2 -translate-x-1/2 -translate-y-1/2"
                src="~/assets/images/Te/TeCourse/PriceTable/price-badge-campaign.svg"
                alt="キャンペーン"
                width="85"
                height="33"
                loading="lazy"
              > -->
              <h3 class="co-display-10 mb-0 font-bold">
                8週間プラン
              </h3>
              <span class="co-display-13 font-normal">集中して学びたい方向け</span>
            </th>
            <!-- 16週間 -->
            <th class="relative w-2/5 border border-[#dee2e6] bg-[#625fb7] px-3 py-0 text-white">
              <!-- バッジ -->
              <img
                class="absolute -top-[3%] left-1/2 -translate-x-1/2 -translate-y-1/2"
                src="~/assets/images/Te/TeCourse/PriceTable/price-badge-sakiwari.svg"
                alt="先割"
                width="61"
                height="34"
                loading="lazy"
              >
              <h3 class="co-display-10 mb-0 font-bold">
                16週間プラン
              </h3>
              <span class="co-display-13 font-normal">焦らず学びたい方向け</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- 料金 -->
          <tr class="h-[6.25rem]">
            <th class="border border-[#dee2e6] px-3">
              セット割料金
              <br>
              （税込）
            </th>
            <!-- 8週間 -->
            <td class="border border-[#dee2e6] px-3">
              <div>
                <b class="mb-0 block font-normal">
                  <span class="co-display-7 px-1 font-bold text-co-success-500">{{ $addComma(standard_week8_price) }}</span> 円
                </b>
              </div>
            </td>
            <!-- 16週間 -->
            <td class="border border-[#dee2e6] px-3">
              <div>
                <b class="mb-0 block font-normal">
                  <span class="co-display-7 px-1 font-bold text-[#625fb7]">{{ $addComma(standard_week16_price) }}</span> 円
                </b>
              </div>
            </td>
          </tr>
          <!-- 受講期間 -->
          <tr class="h-[6.25rem]">
            <th class="border border-[#dee2e6] px-3">
              受講期間
            </th>
            <!-- 8週間 -->
            <td class="border border-[#dee2e6] px-3">
              <b class="mb-2 block font-normal">
                <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
              </b>
              <b class="block font-normal">
                <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt8) }}月{{ dateToDay(membershipEndsAt8) }}日 ({{ dateToWeek(membershipEndsAt8) }})
              </b>
            </td>
            <!-- 16週間 -->
            <td class="border border-[#dee2e6] px-3">
              <b class="mb-2 block font-normal">
                <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
              </b>
              <b class="block font-normal">
                <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt16) }}月{{ dateToDay(membershipEndsAt16) }}日 ({{ dateToWeek(membershipEndsAt16) }})
              </b>
            </td>
          </tr>
          <!-- メンタリング -->
          <tr class="h-[6.25rem]">
            <th class="border border-[#dee2e6] px-3">
              メンタリング
            </th>
            <!-- 8週間 -->
            <td class="border border-[#dee2e6] px-3">
              14回
            </td>
            <!-- 16週間 -->
            <td class="border border-[#dee2e6] px-3">
              30回
            </td>
          </tr>
          <!-- チャットサポート -->
          <tr class="h-[6.25rem]">
            <th class="border border-[#dee2e6] px-3">
              チャットサポート
            </th>
            <td
              class="border border-[#dee2e6] px-3"
              colspan="2"
            >
              <slot name="chatSupportTime">
                24時間以内に回答
              </slot>
            </td>
          </tr>
          <!-- 学習時間の目安 -->
          <tr class="h-[6.25rem]">
            <th class="border border-[#dee2e6] px-3">
              学習時間の目安
              <br class="hidden lg:block">
              （1週間）
            </th>
            <!-- 8週間 -->
            <td class="border border-[#dee2e6] px-3">
              40〜50時間
            </td>
            <!-- 16週間 -->
            <td class="border border-[#dee2e6] px-3">
              20〜25時間
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 別途料金について -->
    <div class="co-container-sm mb-[3.25rem]">
      <div
        v-if="$slots.additionalFees"
        class="mt-5 flex flex-col items-center gap-1 lg:flex-row lg:items-start lg:gap-4"
      >
        <div class="co-display-11 flex items-center gap-1 whitespace-nowrap font-bold text-co-danger-500">
          <FontAwesomeIcon
            :icon="faCircleInfo"
            class="fa-fw size-5"
          />別途料金について
        </div>
        <div>
          <slot name="additionalFees">
            別途料金についてのテキスト
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleInfo } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Methods {
  dateToMonth(date: Date | null): number | '-'
  dateToDay(date: Date | null): number | '-'
  dateToWeek(date: Date | null): string
}

/* eslint-disable camelcase */
interface Computed {
  beginsAt: Date | null
  beginsMonth: number | '-'
  beginsDays: number | '-'
  beginsDayOfWeek: '日' | '月' | '火' | '水' | '木' | '金' | '土' | '-'
  standard_week8_price: number | '-'
  standard_week16_price: number | '-'
  membershipEndsAt8: Date | null
  membershipEndsAt16: Date | null
}
/* eslint-enable camelcase */

interface Props {
  pack: any
  currentPromotion: any
}

const options = {
  setup() {
    return { faCircleInfo }
  },
  props: {
    pack: {
      default: null,
    },
    currentPromotion: {
      default: null,
    },
  },
  filters: {
    addComma(value: number | undefined) {
      return value ? value.toLocaleString() : '-'
    },
  },
  computed: {
    beginsAt() {
      return this.pack ? new Date(this.pack.attributes.begins_at) : null
    },
    beginsMonth() {
      return this.beginsAt ? this.beginsAt.getMonth() + 1 : '-'
    },
    beginsDays() {
      return this.beginsAt ? this.beginsAt.getDate() : '-'
    },
    beginsDayOfWeek() {
      if (this.beginsAt) {
        const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][
          this.beginsAt.getDay()
        ]
        return dayOfWeek as '日' | '月' | '火' | '水' | '木' | '金' | '土'
      } else {
        return '-'
      }
    },
    /* eslint-disable camelcase */
    standard_week8_price() {
      return this.pack ? this.pack.attributes.standard_week8_price : '-'
    },
    standard_week16_price() {
      return this.pack ? this.pack.attributes.standard_week16_price : '-'
    },
    /* eslint-enable camelcase */
    membershipEndsAt8() {
      return this.pack
        ? new Date(this.pack.attributes.membership_ends_at8)
        : null
    },
    membershipEndsAt16() {
      return this.pack
        ? new Date(this.pack.attributes.membership_ends_at16)
        : null
    },
  },

  methods: {
    dateToMonth(date: Date | null) {
      return date ? date.getMonth() + 1 : '-'
    },
    dateToDay(date: Date | null) {
      return date ? date.getDate() : '-'
    },
    dateToWeek(date: Date | null) {
      if (date) {
        const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][
          date.getDay()
        ]
        return dayOfWeek as '日' | '月' | '火' | '水' | '木' | '金' | '土'
      } else {
        return '-'
      }
    },
  },
  components: {
    FontAwesomeIcon,
  }
}

export default defineNuxtComponent(options)
</script>

<style scoped>
/* SP表示 */
.tabs {
  grid-template-columns: repeat(auto-fit, minmax(50%, 1fr));
}

/* 選択されたタブのスタイル */
.tabs-boxed :is(input:checked) {
  @apply text-white;
}

.tabs-boxed :is(input:checked.te-tab-8weeks) {
  @apply bg-co-success-500;
}

.tabs-boxed :is(input:checked.te-tab-16weeks) {
  @apply bg-[#625fb7];
}

/* 背景色 */
.te-price-striped:nth-of-type(odd),
.table tbody tr:nth-of-type(odd) {
  @apply bg-[#f9f9f9];
}

.te-price-striped:nth-of-type(even),
.table tbody tr:nth-of-type(even) {
  @apply bg-white;
}

/* // 16週間プラン */
.te-text-plan-16w {
  color: #625fb7;
}

.te-bg-plan-16w {
  background-color: #625fb7;
}

.te-balloon-triangle-down {
  width: 0;
  height: 0;
  border-color: #1ba9f5 transparent transparent;
  border-style: solid;
  border-width: 6px 6px 0;
}

.te-reskill-balloon {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  color: #ff3;
  background: #1ba7f5;
}

.te-tax-text {
  font-size: 0.625rem;
  @media (min-width: 768px) {
    font-size: 0.75rem;
  }
}
</style>
